import React from "react";
import { ContactGroupIcon } from "@fluentui/react-icons-northstar";
import { ReportFilterBase } from "./abstractions/ReportFilterBase";
import { IntermediaryNumber, Segment } from "../models";

export interface IntermedaryFilterProps {
    intermediaryList: IntermediaryNumber[];
    onSelectedIntermediaryChanged: (intermediaryList: IntermediaryNumber[]) => void;
    isMobileView: boolean;
}

export const IntermedaryFilter: React.FC<IntermedaryFilterProps> = ({
    intermediaryList,
    onSelectedIntermediaryChanged,
    isMobileView,
}) => {
    return (
        <ReportFilterBase
            icon={<ContactGroupIcon outline />}
            prefix={`Agencja`}
            items={intermediaryList}
            multiple={false}
            onSelectedItemsChanged={(modes) => onSelectedIntermediaryChanged(modes as IntermediaryNumber[])}
            clearable
            isMobileView={isMobileView}
        />
    );
};
